enum LCEvent {
    ONLINE = 'online',
    OFFLINE = 'offline',
    FOREGROUND = 'foreground',
    BACKGROUND = 'background',
    NOTIFICATION = 'notification',
    // Internal
    TOKEN_RENEWED = 'token_renewed',
    NEW_POSITION = 'new_position',
    // Didomi
    RGPD_READY = 'rgpd_ready',
}

export default LCEvent;
